import Navbar from "./components/Navbar.jsx";

function LaserLandingpage() {
  return (
    <>
      <Navbar />
    </>
  );
}

export default LaserLandingpage;
